import React from "react";
import Footer from "../components/Footer";
import 'animate.css';
const App = () => {
  return (
    <section>
      <main className="p-[8%]">
        <div className="max-sm:pt-[60px] ">
          <img
            className="w-full object-contain animate__animated  animate__backInRight"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fdata_headings.affd17ec.png&w=3840&q=75"
            alt="app_img"
          />
        </div>

        <div
          id="app__second"
          className="flex pt-7 max-lg:flex-col max-md:flex-col animate__animated animate__backInUp "
        >
          <div
            id="feature_text"
            className="md:w-60% flex w-full flex-col justify-center gap-3 p-[5%] max-sm:w-[80%%] max-sm:text-[9px] sm:items-center "
          >
            <div>
              <h1 className="text-2xl text-green-900 max-sm:text-[16px]">
                HOW DO WE STAND OUT FROM THE CROWD?
              </h1>
              <p className="flex items-center justify-center text-start">
                We can achieve it all through an intuitive interface, innovative
                features, personalized interactions, high performance, and
                captivating visuals.
              </p>
            </div>
            <ul className="space-y-3 pl-[10%] text-sm max-sm:text-[9px]">
              <li>
                Crafting an interface that is easy to navigate and understand
                enhances user interaction, fostering a positive and seamless
                experience. We excels in creating navigation structures that
                users can effortlessly grasp, reducing friction and enhancing
                overall usability.
              </li>
              <li>
                Ensuring swift load times and smooth functionality enhances user
                satisfaction and encourages extended usage. Our approach
                involves meticulous coding, regular performance evaluations, and
                continuous updates to make sure that our apps remain fast,
                reliable, and enjoyable across various devices.
              </li>
              <li>
                Eye-catching graphics, animations, and design elements create an
                aesthetically pleasing environment that enhances user
                engagement. We ensure a seamless and visually appealing
                interface by blending colors, typography, and design
                harmoniously.
              </li>
            </ul>
          </div>
          <div className="flex w-[40%] max-lg:w-full max-md:w-full ">
            <img
              className="h-auto w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_details_img1.9f750369.png&w=1920&q=75"
              alt="app_img"
            />
          </div>
        </div>
      </main>
      <div
        id="app_third"
        className="mt-10 flex w-full justify-between bg-[#262730] p-[5%] max-sm:flex-col max-sm:gap-10 "
      >
        <div
          id="app_third_item"
          className="flex w-[30%] flex-col items-center justify-center gap-2 text-center text-white max-sm:w-full "
        >
          <img
            className=",max-h-full h-[10vh] w-[10vh] max-w-full object-contain "
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_details_icon.c98cecf5.png&w=640&q=75"
            alt="app_img"
          />
          <h1 className="text-lg">Stand out from the competition</h1>
          <p className="text-sm text-[#8bb7c4]">
            Creating the finest application that caters to distinct user needs
          </p>
        </div>

        <div
          id="app_third_item"
          className="flex w-[30%] flex-col items-center justify-center gap-2 text-center text-white max-sm:w-full "
        >
          <img
            className=",max-h-full h-[10vh] w-[10vh] max-w-full object-contain"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_details_icon1.0d4c1bfa.png&w=384&q=75"
            alt="app_img"
          />
          <h1 className="text-lg">Innovative features</h1>
          <p className="text-sm text-[#8bb7c4]">
            Upgrading in-game features that genuinely enhance the user
            experience
          </p>
        </div>

        <div
          id="app_third_item"
          className="flex w-[30%] flex-col items-center justify-center gap-2 text-center text-white max-sm:w-full "
        >
          <img
            className=",max-h-full h-[10vh] w-[10vh] max-w-full object-contain"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_details_icon2.c1fb49d3.png&w=640&q=75"
            alt="app_img"
          />
          <h1 className="text-lg">Optimizing marketing creatives</h1>
          <p className="text-sm text-[#8bb7c4]">
            Blending compelling visuals and persuasive mess12 aging
          </p>
        </div>
      </div>
      <div
        id="app_forth_1st"
        className="mx-10 flex space-x-10 p-[5%] max-md:flex-col-reverse max-md:gap-10"
      >
        <div className="flex w-[40%] max-md:w-full">
          <img
            className="max-h-full max-w-full object-contain "
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_banner_img1.45e10029.png&w=1920&q=75"
            alt="app_img"
          />
        </div>

        <div
          id="app__text"
          className="md:w-60% flex w-[60%] flex-col  justify-center gap-3 max-md:w-full max-md:items-center sm:items-center "
        >
          <div>
            <h1 className="text-2xl text-green-900">
              PROFIT THROUGH SUSTAINABLE GAMING GROWTH
            </h1>
            <p className="flex items-center justify-center">
              Get ready to dive into the puzzle world of Traffic Jam Cars
              Puzzle. The modern match 3 game has left indelible milestones
              worldwide.
            </p>
          </div>
          <ul className="space-y-3 pl-[3%] text-sm">
            <li>
              A remarkable presence in the top 100 highest-grossing mobile games
              across 53 countries: #50 in Japan, #150 in Germany, #80 in the
              United States, #150 in Great Britain, and #200 in South Korea.
            </li>
            <li>
              Every aspect of Traffic Jam Cars Puzzle is meticulously designed
              to ensure that players receive the best. Addictive and challenging
              are the the two main cores of this game.
            </li>
            <li>
              Long-term engagement and lasting returns are the hallmarks of high
              quality games. Traffic Jam Cars Puzzle does not coerce users into
              immediate monetization. Instead, it focuses on cultivating lasting
              relationships by delivering unique gameplay that keeps players
              entertained for years.
            </li>
          </ul>
        </div>
      </div>

      <div
        id="app_forth_2nd"
        className="mx-10 flex space-x-10 p-[5%] pb-5 max-md:flex-col max-md:gap-10"
      >
        <div className="md:w-60% flex w-[60%] flex-col  gap-3 max-md:w-full max-sm:w-full max-sm:items-center max-sm:justify-center max-sm:p-0 sm:items-center  ">
          <h1 className="w-full text-2xl text-green-900">
            HMU - ADD ME AND GET FRIEND
          </h1>
          <h3 className="text-sm">
            HMU is the platform for connecting with people globally. It is the
            answer for anyone seeking a refreshing change from their daily
            routine. Say goodbye to mundane interactions, as HMU offers an
            exciting avenue to form new friendships and connect with individuals
            across the globe. With HMU, making friends online has never been
            more engaging and convenient.
          </h3>
        </div>

        <div className="flex w-[40%] items-center justify-center max-md:w-full max-sm:justify-center">
          <img
            className="object-fit max-h-full max-w-full"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fapp_banner_img2.ca278f02.png&w=1920&q=75"
            alt="app_img"
          />
        </div>
      </div>

      <div id="app__fifth" className="mb-[40px] p-[5%] ">
        <h1 className="text-[30px] text-[#157a70]">NEWS</h1>

        <div className="flex flex-row gap-10 max-md:flex-col max-md:space-y-24 max-sm:flex-col ">
          <div
            id="app__fifth_left"
            className="flex h-[400px] w-[50%] flex-col gap-5 max-md:w-full"
          >
            <img
              className="h-full w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fdata_latestpost_img1.d156ed6b.png&w=1920&q=75"
              alt="app_img"
            />
            <h1 className="text-[24px] text-[#157a70]">
              Use Chat GPT for Effective Keyword Research
            </h1>
            <p className="text-[16px] text-[#6b6b6b]">
              By harnessing the capabilities of AI-driven language generation,
              you can delve into the minds of your users, extracting the precise
              terms that resonate. This process not only streamlines your app is
              visibility but also propels your offerings to the forefront of
              search results. This article offers a set of guidelines and
              techniques for effectively constructing keyword research prompts
              in Chat GPT.
            </p>
          </div>

          <div
            id="app__fifth_right"
            className="flex h-[400px] w-[50%] flex-col gap-5 max-md:w-full"
          >
            <img
              className="h-full w-full object-contain"
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fdata_latestpost_img2.f69d6f43.png&w=1920&q=75"
              alt="app_img"
            />
            <h1 className="text-[24px] text-[#157a70]">
              Avoid Apple App Store Rejection With These Notices
            </h1>
            <p className="text-[16px] text-[#6b6b6b]">
              Navigating the app store submission process can be intricate, but
              there are key strategies to ensure your app avoids rejection.
              Start by thoroughly reviewing the platform is guidelines and
              policies. Pay particular attention to technical requirements,
              content restrictions, and privacy regulations.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default App;
